module.exports = __webpack_public_path__ + "img/device-6.66417c84.png";